import React, { useState } from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [],
  modifiers: [
    {
      title: 'default',
      isDefault: true
    },
    'inverse'
  ],
  states: []
}

const Toggle = (props) => {
  const {
    id,
    value,
    disabled,
    inverse,
    checked = false,
    parentId,
    parentClassName,
    onChange,
    ...rest
  } = props

  const [isChecked, setIsChecked] = useState(!!checked)

  const _input = React.useRef(null)

  React.useEffect(() => {
    setIsChecked(!!checked)
    _input.current.checked = !!checked
  }, [props.checked])

  const handleKeyPress = (e) => {
    if (e.charCode === 32 || e.charCode === 13) {
      handleToggle()
    }
  }

  const handleToggle = (disabled = false) => {
    if (disabled) return
    const status = !isChecked
    setIsChecked(status)
  }
  return (
    <div
      id={props.parentId}
      tabIndex={0}
      onKeyPress={(e) => handleKeyPress(e)}
      className={
        resolveProps(props, config, 'Toggle') + ' ' + (parentClassName || '')
      }
      onClick={() => handleToggle(disabled)}
    >
      <div className="mdn-Toggle-list">
        <input
          {...rest}
          id={id}
          className="mdn-Toggle-item mdn-Toggle-item-primary"
          type="checkbox"
          role="checkbox"
          ref={_input}
          onChange={(e) => !!onChange && onChange(e, isChecked)}
          value={value || isChecked}
          checked={isChecked}
          disabled={disabled}
        />
        <label className="mdn-Toggle-button" htmlFor={id} />
      </div>
    </div>
  )
}

export default Toggle

Toggle.propTypes = {
  etc: PropTypes.object,
  parentId: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  inverse: PropTypes.bool,
  parentClassName: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string
}
